import { pushClickEvent } from "analytics/manager"

const handleDownloadApp = (event?: any, params?: any) => {
  const clickURL = window?.AF_SMART_SCRIPT_RESULT?.clickURL

  const redirectUrl = /iPad|iPhone|iPod/.test(navigator.userAgent)
    ? "https://apps.apple.com/in/app/sixer-fantasy-cricket-stocks/id1501810270"
    : "https://storage.googleapis.com/sixerapp_android/builds/release/Sixerapp.apk"

  event && pushClickEvent(event, params)

  console.debug({
    appsFlyerUrl: clickURL,
    defaultUrl: redirectUrl,
  })

  window.location.href = clickURL || redirectUrl
}

export const MobileDownloadManager = handleDownloadApp
export const IosDownloadManager = handleDownloadApp
export const AndroidDownloadManager = handleDownloadApp
